// 用户中心-用户订单操作板块
const UserOrderRouterMap = [
  // =========================================   用户中心板块  =====================================
  // 我的订单列表
  {
    path: '/user/order',
    component: OrderList => (require(['@/views/order/order'], OrderList))
  },
  // 我的订单详情
  {
    path: '/order/info',
    component: OrderInfo => (require(['@/views/order/orderInfo'], OrderInfo))
  },
  // 订单支付
  {
    path: '/user/order-share-info/:shareId',
    component: OrderPay => (require(['@/views/order/orderShareInfo'], OrderPay))
  },
  // 退款追踪
  {
    path: '/order/refund-track',
    component: RefundTrack => (require(['@/views/order/refundTrack'], RefundTrack))
  },
  // 退款规则
  {
    path: '/order/refund-rule/:orderId',
    component: RefundRule => (require(['@/views/order/refundRule'], RefundRule))
  },
  // 用户预售
  {
    path: '/order/reserve',
    component: Reserve => (require(['@/views/order/reserve'], Reserve))
  },
  // =========================================   用户下单流程  =====================================
  // 创建订单
  {
    path: '/order/create/:tripOriginalId',
    meta: {index: 1, title: '稻草人旅行-创建订单'},
    component: Reserve => (require(['@/views/order/orderCreate'], Reserve))
  },
  // 支付订单
  {
    path: '/order/pay/:orderIds',
    meta: {index: 1, title: '稻草人旅行-支付订单'},
    component: Reserve => (require(['@/views/order/orderPay'], Reserve))
  },
  // 申请退订页面
  {
    path: '/order/order-refund',
    meta: {index: 1, title: '稻草人旅行-申请退订'},
    component: orderRefund => (require(['@/views/order/orderRefund'], orderRefund))
  },
  // 疫情减免申请页面
  {
    path: '/order/apply-for-unsubscribe',
    meta: {index: 1, title: '稻草人旅行-疫情减免申请'},
    component: OrderApplyForUnsubscribe => (require(['@/views/order/orderApplyForUnsubscribe'], OrderApplyForUnsubscribe))
  },
  // 改签页面
  {
    path: '/change/:shareId',
    meta: {index: 1, title: '稻草人旅行-改签页面'},
    component: Reserve => (require(['@/views/order/orderChange'], Reserve))
  }
]

export default UserOrderRouterMap



// WEBPACK FOOTER //
// ./src/router/modules/order/order.js